// removed by extract-text-webpack-plugin
module.exports = {"flex-box":"flex-box__3Gvkm","CTA-desktop":"CTA-desktop__2HlS2","text-yellow":"text-yellow__3mkHH","top-cta-form":"top-cta-form__3-x2k","btn-green":"btn-green__afj6y","invest-btn-text":"invest-btn-text__1CFlI","app-text":"app-text__3gfn2","btn-blue":"btn-blue__1oBmv","input-field":"input-field__3VnfT","captcha":"captcha__bIy3w","captcha-01":"captcha-01__2z5eU","g-recaptcha-response":"g-recaptcha-response__1QKm5","captcha-iframe-02":"captcha-iframe-02__24n_L"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/topBlackBanner.scss
// module id = 745
// module chunks = 68